export const THUMBNAIL_MODE_WIDTH = 600;
